import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../customComponents/CustomTable';
import downloadIcon from './../../../../../Assets/icons/download.svg';
import './index.scss';
import editIcon from './../../../../../Assets/icons/Un-Checkbox.svg';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import Loader from '../../../../customComponents/CustomLoader';
import SearchInput from '../../../../customComponents/CustomSearch/SearchInput';

const ProductFuelTypeList = () => {
  const [fuelTypeData, setFuelTypeData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [ totalData, setTotalData ] = useState(0)
  const [totalActive, setTotalActive] = useState(0)
  const [ totalInactive, setTotalInactive ] = useState(0)
  const [searchTerm, setSearchTerm] = useState('');

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchFuelTypeList(newPage);
  };

  const fetchFuelTypeList = async (page = 0, pageSize = 10) => {
    try {
      setLoading(false)
      const response = await axiosInstance.post('/fueltype/list', {
        orderBy: 'fuel_type_id desc',
        page,
        pageSize,
        searchText:searchTerm
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1  
      }));

      const totalRecordsData = response?.data?.data?.totalRecords

      const totalCount = response?.data?.data?.total
      const totalAct = response?.data?.data?.total_active
      const totalInac = response?.data?.data?.total_inactive

      setTotalData(totalCount)
      setTotalActive(totalAct)
      setTotalInactive(totalInac)

      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      setFuelTypeData(formattedData); 
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize)); 
    } catch (error) {
      console.error('Error fetching fuel type list:', error);
    }
    finally{
      setLoading(false)
    }
  };

  const TABLE_HEADERS = [
    "Name",
    "Description",
    "Status",
    "Action"
  ];

  const keyMapping = {
    "Name": "fuel_type_name",
    "Description": "fuel_type_desc",
    "Status": "status",
    "Action": [
      { type: "edit", icon: editIcon, label: "Edit" },
    ]
  };

  const handleEdit = (rowData) => {
    navigate(`${ROUTES_NAVIGATION.EDITPRODUCTFUELTYPE}`, { state: { data: rowData } });
  }
  useEffect(() => {
    if (searchTerm === "") {
      fetchFuelTypeList();
    }
  }, [searchTerm]);
  return (
    <div>
    {loading ? (
      <Loader/>
    ) : (
      <><div className='OnboardManagamentContainer'>
            <div className='OnboardManagamentbuttonContainer'>
              <h5>Fuel Type Management</h5>
            </div>
            <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
              <div className='topleftdataContainer' style={{ borderRight: "1px solid lightgrey" }}>
                <h5 className="listTopDataValueText">{totalData} </h5>
                <h6>All Fuel Type</h6>
              </div>
              <div className='topleftdataContainer' style={{ borderRight: "1px solid lightgrey" }}>
                <h5 className="listTopDataValueText">{totalActive} </h5>
                <h6>Active Fuel Type</h6>
              </div>
              <div className='topleftdataContainer'>
                <h5 className="listTopDataValueText">{totalInactive} </h5>
                <h6>Inactive Fuel Type</h6>
              </div>
              <button className='addcustomerbutton' onClick={() => navigate('/admin/manage-product/fuel-type/add-fuel-type')}>
                Add Fuel Type
              </button>
            </div>
          </div><div className='tableWrapper'>
              <div className='admin-list-container'>
                <div className='listsearchContainer'>
                  <h5>FuelType List</h5>
                  <div>
              <SearchInput
                placeholder="Search Fuel Type"
                onSearch={fetchFuelTypeList}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
              </div>
                </div>
              </div>
              <CustomTable
                data={fuelTypeData}
                headers={TABLE_HEADERS}
                keyMapping={keyMapping}
                itemsPerPage={10}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onEdit={handleEdit}
                totalRecords={totalRecords} />
            </div></>
        )}
    </div>
  );
};

export default ProductFuelTypeList;
